/**
 * DEBUG BUILD ONLY — arm the WebRTC debug-logging gate before any manager module reads it.
 *
 * Vite's `define: { PLAYCAST_DEBUG_WEBRTC }` is only substituted in BUILD output. The
 * dev server serves the bare identifier, so `isDebugWebrtcLoggingEnabled()` would read
 * `typeof PLAYCAST_DEBUG_WEBRTC === 'undefined'` and the whole rig (clientStats/guestDebug
 * datachannel logging, [Recovery.*] lines, the NDJSON sink) would stay off in every
 * `yarn serve-all:dev` session.
 *
 * App entries must call `armWebrtcDebugLogging()` FIRST (before anything that pulls in
 * PeerCore's managers), because those managers snapshot the gate at module load:
 * `const DEBUG_WEBRTC_LOGGING = isDebugWebrtcLoggingEnabled()`. `isDev` is supplied by the
 * caller (the app's `import.meta.env.DEV` — the lib itself cannot use `import.meta` under
 * its tsconfig). Pass `true` only for development-mode builds; production call sites
 * dead-code this branch via their own `import.meta.env.DEV`.
 */
export function armWebrtcDebugLogging(isDev: boolean): void {
  if (isDev) {
    (globalThis as Record<string, unknown>)['PLAYCAST_DEBUG_WEBRTC'] = '1';
  }
}